import React, { useEffect } from 'react';

/**
 * Commercial Landing Page
 * Redirects to the static HTML commercial landing page
 * This serves as the main entry point for canopylifestyle.com
 */
export function CommercialLandingPage() {
    useEffect(() => {
        // Redirect to the static commercial landing page
        window.location.href = '/docs/canopy-commercial-landing.html';
    }, []);

    // Show a brief loading state while redirecting
    return (
        <div className="min-h-screen bg-[#4a6741] flex items-center justify-center">
            <div className="text-center">
                <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4" />
                <p className="text-white/80 text-lg">Loading Canopy...</p>
            </div>
        </div>
    );
}

export default CommercialLandingPage;
